<template>
  <base-page>
    <div class="card goods">
      <a-row v-if="goods" :gutter="[16,16]">
        <a-col :xs="24" :sm="8" :md="8" :lg="6" :xl="6">
          <carousel-images :goods="goods"/>
        </a-col>
        <a-col :xs="24" :sm="16" :md="16" :lg="18" :xl="18">
          <div class="goods-cnt">

            <div>
              <div class="title">
                {{ goods.title }}
              </div>
              <div class="ids">
                ID: {{ goods.id }}
                <a-icon type="copy" style="margin-right: 8px;color: #0066ff;cursor: pointer;" @click="handleCopy(goods.id)"/>
              </div>
              <!--              <div class="desc">-->
              <!--                来自丹顶鹤之乡-齐齐哈尔，黑土地稀有肥沃，精良培育稻种。（丹顶鹤对环境变化十分敏感，对栖息地的水质、植被、气候、食物等要求十分高。在全球只有不到万分之一的土地适合丹顶鹤栖息。-->
              <!--              </div>-->
              <div class="tags">
                <div v-if="goods.coupon !== '0'" class="tag">领劵立减{{ goods.coupon }}元</div>
                <div v-if="goods.commission !== '0'" class="tag">收货后返现{{ goods.commission }}元</div>
              </div>
            </div>

            <div>
              <div class="coupones">
                <div class="coupone">
                  <div class="title">券后价</div>
                  <div style="display: flex;height: 44px;align-items: flex-end;">
                    <div class="price">￥<span style="font-size: 25px;">{{ goods.cost_price }}</span></div>
                    <div class="desc"> / <span style="text-decoration: line-through;">￥{{ goods.price }}</span></div>
                  </div>
                </div>
                <div class="coupone">
                  <div class="title">佣金比例</div>
                  <div style="display: flex;height: 44px;align-items: flex-end;">
                    <div class="price"><span style="font-size: 25px;">{{ goods.commission_rate }}</span>%</div>
                    <div class="desc">预估佣金：￥{{ goods.commission }}</div>
                  </div>
                </div>
              </div>
              <div v-if="selectSku && selectSku.length > 0" class="skus">
                <div v-for="(sku, idx) in selectSku" :key="'sku_' + idx" class="sku">
                  <div class="title">{{sku.name}}</div>
                  <div class="price">{{sku.value}}</div>
                </div>
              </div>
              <div v-if="specs && specs.length > 0" class="spec-cnt">
                <div v-for="spec in specs" :key="spec.name" class="specs">
                  <div class="spec-name">{{spec.name}}:</div>
                  <div class="spec-items">
                    <div v-for="it in spec.item" :key="it.id" class="spec-item" :class="selectedId === it.id ? 'selected' : 'normal'" @click="selectedId = it.id">
                      {{it.name}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="sales">
                <!--                <div class="item">月销量<span class="value">1万</span></div>-->
                <div class="item">已售<span class="value">{{ goods.sales }}</span></div>
              </div>
              <div class="buttons">
                <div class="button collection" @click="handleCollection">
                  <a-icon type="star" style="margin-right: 4px;"/>
                  收藏
                </div>
                <div class="button join" @click="handleAddWindow">加入橱窗</div>
                <div class="button share" @click="handleShare">分享赚￥{{ goods.share_commission }}</div>
                <div v-if="userInfo" class="button join" @click="handleCopyLink">复制链接</div>
                <div v-if="userInfo" class="button share" @click="handleDownloadAll">批量下载图片</div>
              </div>
            </div>

          </div>
        </a-col>
      </a-row>
    </div>

    <a-row :gutter="[16,16]">
      <a-col :xs="0" :sm="0" :md="8" :lg="6" :xl="6">
        <div class="card recommand">
          <recommand-goods v-if="gid" :gid="gid" :pvd="pvd"/>
        </div>
      </a-col>
      <a-col :xs="24" :sm="24" :md="16" :lg="18" :xl="18">
        <div class="card detail">
          <div class="header">
            商品详情
          </div>
          <div v-if="goods" class="images">
            <div v-for="(img, idx) in goods.detail_img_list" :key="'img_' + idx" :ref="'img_' + idx" :id="'img_' + idx">
              <img :src="img" class="img"/>
            </div>

          </div>
        </div>
      </a-col>
      <!--      <a-col :xs="24" :sm="24" :md="0" :lg="0" :xl="0" >-->
      <!--        <div class="card recommand">-->
      <!--          <recommand-goods v-if="gid" :gid="gid"/>-->
      <!--        </div>-->
      <!--      </a-col>-->
    </a-row>

    <zy-add-collection-dialog ref="addCollection"/>
    <zy-add-window-dialog ref="addWindow"/>
    <zy-share-dialog ref="shareGoods"/>
  </base-page>
</template>

<script>
import BasePage from "@/components/base-page/index.vue";
import CarouselImages from "./carousel-images.vue";
import RecommandGoods from "./recommand-goods.vue"
import ZyAddCollectionDialog from "@/components/zy-add-collection-dialog/index.vue";
import ZyAddWindowDialog from "@/components/zy-add-window-dialog/index.vue";
import ZyShareDialog from "@/components/zy-share-dialog/index.vue";
import {fetchGoodsDetail, fetchGoodsLink, fetchSku, fetchSpec} from "@/api/goods-list";
import JSZip from "jszip";
import {saveAs} from 'file-saver'
import {createNamespacedHelpers} from 'vuex'
import {setClipboardData} from "@/components/zy-share-dialog/utils";

const {mapGetters} = createNamespacedHelpers('user')


export default {
  name: "index",
  components: {
    BasePage,
    CarouselImages,
    RecommandGoods,
    ZyAddCollectionDialog,
    ZyAddWindowDialog,
    ZyShareDialog
  },
  watch: {
    $route: {
      handler() {
        console.log(this.$route.query.id)
        const {id, pvd} = this.$route.query
        this.gid = id
        this.pvd = pvd
        this.reload()
      },
      immediate: true
    },
    selectedId: {
      handler() {
        this.fetchSku()
      }
    }
  },
  computed: {
    ...mapGetters({userInfo: 'getUserInfo'}),
  },
  data() {
    return {
      gid: '',
      pvd: '',
      goods: undefined,
      specs: [],
      selectedId: '',
      selectSku: [],
    }
  },
  methods: {
    reload() {
      fetchGoodsDetail({gid: this.gid, type: this.pvd}).then(res => {
        this.goods = res
        this.fetchSpec()
      })
    },
    handleCollection() {
      this.$refs.addCollection.show({good_id: this.gid, provider: this.pvd})
    },
    handleAddWindow() {
      this.$refs.addWindow.show({good_id: this.gid, provider: this.pvd})
    },
    handleShare() {
      this.$refs.shareGoods.show({good_id: this.gid, provider: this.pvd})
    },
    fetchSpec() {
      this.specs = []
      fetchSpec({
        commission:this.goods.commission,
        gid:this.goods.gid,
        isTeam:this.goods.gid,
        price: this.goods.price,
        provider: this.goods.provider,
        yhq_price: ""
      }).then(res => {
        console.log(res)
        if (res.spec) {
          this.specs = res.spec
          if (this.specs && this.specs.length > 0 && this.specs[0].item[0]) {
            this.selectedId = this.specs[0].item[0].id
          }
        }
      })
    },
    fetchSku() {

      fetchSku({
        commission:this.goods.commission,
        gid:this.goods.gid,
        isTeam:this.goods.gid,
        price: this.goods.price,
        provider: this.goods.provider,
        yhq_price: "",
        sku_id: this.selectedId
      }).then(res => {
        if (res.list) {
          this.selectSku = res.list
        } else {
          this.selectSku = []
        }
      })
    },
    async handleDownloadAll() {
      const images = [
        this.goods.img_list,
        this.goods.detail_img_list,
      ]
      var imgBase64 = []
      for (var j = 0; j < images.length; j++) {
        var imgList = images[j]
        var base64s = []
        for (var i = 0; i < imgList.length; i++) {
          const base64 = await this.getBase64(imgList[i])
          base64s.push(base64.substring(22))
        }
        imgBase64.push(base64s)
        console.log(imgBase64)
      }
      this.zipImage(imgBase64)
    },
    zipImage(imgBase64) {

      var zip = new JSZip()
       var folderName = this.goods.title
      var img = zip.folder()
      const that = this

      setTimeout(function () {

        for (var j = 0; j < imgBase64.length; j++) {
          for (var i = 0; i < imgBase64[j].length; i++) {
            var dirname = ''
            if (j == 0) dirname = '主图'
            if (j == 1) dirname = '详情图'
            const filename = `${dirname}_${i + 1}`
            img.file(`${dirname}/${filename}.jpg`, imgBase64[j][i], {base64: true})
          }
        }
        zip.generateAsync({type: 'blob'}).then(function (content) {
          // see FileSaver.js
          saveAs(content, `${folderName}.zip`)
          that.$message.success(`图片下载成功！`, 5)
        })

      }, 100)
    },

    getBase64(img) {
      console.log(img)
      // width、height调用时传入具体像素值，控制大小 ,不传则默认图像大小
      function getBase64Image(img, width, height) {
        var canvas = document.createElement('canvas')
        canvas.width = width || img.width
        canvas.height = height || img.height

        var ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
        var dataURL = canvas.toDataURL()
        console.log(dataURL)
        return dataURL
      }

      return new Promise((resolve) => {
        var image = new Image()
        image.crossOrigin = 'Anonymous'
        image.src = img
        if (img) {
          image.onload = function () {
            // 读取图片之后的操作
            resolve(getBase64Image(image))
          }
        }
      })
    },
    handleCopy(content) {
      setClipboardData(content).then(() => {
        this.$message.success('复制成功');
      })
    },
    handleCopyLink() {
      fetchGoodsLink({gid: this.goods.gid, isTeam: this.goods.is_team, provider: this.goods.provider}).then(res => {
        console.log(res)
        this.handleCopy(res.url)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.card {
  background: #FFFFFF;
  border-radius: 12px;
  padding: 20px;
}

.goods {
  margin-top: 40px;

  .goods-cnt {
    min-height: 340px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .title {
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    line-height: 22px;
    max-height: 400px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .ids {
    ont-size: 13px;
    color: #999999;
    display: flex;
    align-items: center;
    margin-top: 8px;

  }

  .desc {
    font-size: 13px;
    color: #4F4F4F;
    line-height: 24px;
    margin-top: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .tags {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;

    .tag {
      height: 26px;
      background: #FFE9F9;
      border-radius: 3px;
      padding-left: 8px;
      padding-right: 8px;
      line-height: 26px;
      font-size: 13px;
      color: #FF0000;
      margin-right: 5px;
    }
  }

  .coupones {
    max-width: 700px;
    margin-top: 34px;
    background: rgba(255, 141, 197, 0.11);
    border-radius: 6px;
    padding: 16px 10px;
    white-space: nowrap;
    overflow-x: scroll;
    overflow-y: hidden;

    .coupone {
      display: inline-block;
      width: 217px;
      height: 90px;
      background: #FFFFFF;
      border-radius: 6px;
      padding: 10px;
      margin-right: 8px;

      .title {
        font-size: 13px;
        color: #000000;
        line-height: 18px;
      }

      .price {
        font-size: 15px;
        font-weight: 500;
        color: #FF3D3D;
        line-height: 21px;
      }

      .desc {
        font-size: 13px;
        color: #727272;
        line-height: 18px;
        margin-left: 4px;
      }
    }
  }

  .skus {
    display: flex;
    align-items: center;
    padding: 20px;
    max-width: 700px;

    border-radius: 6px;
    border: 1px solid #E4E4E4;
    margin-top: 10px;
    margin-bottom: 10px;

    .sku {
      width: 80px;
      //height: 90px

      background: #FFFFFF;
      border-radius: 6px;
      margin-right: 8px;

      .title {
        font-size: 13px;
        color: #000000;
        line-height: 18px;
      }

      .price {
        font-size: 15px;
        font-weight: 500;
        color: #FF3D3D;
        line-height: 21px;
      }

    }
  }

  .spec-cnt {
    max-width: 700px;
    background: #FFFFFF;
    border-radius: 6px;
    border: 1px solid #E4E4E4;
    font-weight: 500;
    padding: 20px;
    display: flex;
    flex-direction: column;
    .specs {
      display: flex;

      .spec-name {
        flex-shrink: 0;
        font-size: 14px;
        margin-right: 10px;
        line-height: 30px;
      }
      .spec-items {
        flex-grow: 1;
        display: flex;
        flex-wrap: wrap;

        .spec-item {
          cursor: pointer;
          font-size: 14px;
          font-weight: 400;
          color: #333;
          border-radius: 4px;
          padding: 0 8px;
          line-height: 30px;
          text-align: center;
          margin-right: 8px;
          margin-bottom: 4px;
        }

        .normal {
          color: #333333;
          background: #f8f8f8;
        }
        .normal:hover {
          background: #d8d8d8;
        }

        .selected {
          background: #fff5f5;
          color: #ff4242;
        }
      }
    }

  }

  .sales {
    max-width: 700px;
    background: #FFFFFF;
    border-radius: 6px;
    border: 1px solid #E4E4E4;
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    line-height: 50px;
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;

    .item {
      margin-left: 20px;
      margin-right: 20px;
    }

    .value {
      color: #FF1E1E;
    }
  }

  .buttons {
    margin-top: 25px;
    display: flex;
    flex-wrap: wrap;

    .button {
      height: 40px;
      font-size: 14px;
      font-weight: 500;
      line-height: 40px;
      padding-left: 10px;
      padding-right: 10px;
      margin-right: 18px;
      border-radius: 6px;
      cursor: pointer;
    }

    .collection {
      background: linear-gradient(232deg, #00AFFF 0%, #2934F8 100%);
      border-radius: 6px;
      color: #FFFFFF;
    }

    .join {
      color: #6653FF;
      background: #E4E2FE;
    }

    .share {
      border: 1px solid #C200FA;
      color: #C200FA;
    }
  }
}

.recommand {
  margin-top: 22px;

  .header {
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    line-height: 22px;
  }
}

.detail {
  margin-top: 22px;

  .header {
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    line-height: 22px;
    text-align: center;
  }

  .images {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 10px;

    .img {
      width: 100%;
      height: auto;
      object-fit: cover;
    }
  }
}
</style>
